import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/file-document-check-outline';

const routes: RouteRecordRaw[] = [
	{
		// Every path under /documents-review opens this page, so a link deep into Document review
		// (/documents-review/<kind>, /documents-review/<kind>/<grouping name>/<grouping value>) works:
		// the remote reads the rest of the path itself.
		path: '/documents-review/:pathMatch(.*)*',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			// Checked synchronously in the router's global guard, so a direct navigation cannot reach the
			// page before the layout's post-mount redirect fires.
			isAllowed: ({ canAccessDocumentReview }) => canAccessDocumentReview || ROOT_PAGES.MODULES,
			documentTitle: 'Document review',
			title: 'Document review',
		},
	},
];

/**
 * Document review is not built in this repository: it is part of motorway/mw-documents-processing,
 * loaded at runtime as a Module Federation remote (lib/remote.ts). Gated on the documents_access
 * permission, whatever the agent's role; see `canAccessDocumentReview` in src/core/services/user/store.ts.
 */
export const DOCUMENTS_REVIEW_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'Document review',
	description: "Review what was read from sellers' documents, a document type at a time",
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessDocumentReview }) => canAccessDocumentReview,
	routes,
};
